// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1979":"01905d89db1a1c4e","7929":"23aee61ca2bb5db8"}[chunkId] + ".css";
};